import { FC, ReactNode } from 'react';
import styles from './FactoidsList.css';

interface IFactoidsListProps {
  list: ReactNode;
  showMoreButton: ReactNode;
}

export const FactoidsList: FC<IFactoidsListProps> = ({ list, showMoreButton }) => {
  return (
    <>
      <div className={styles['factoids-list']}>{list}</div>
      <div className={styles['show-more-button']}>{showMoreButton}</div>
    </>
  );
};
